export const DUPLICATED_SCHEDULED_CONFIGURATION_ERROR_MESSAGE =
  'Cannot add a duplicated scheduling configuration.';

export const SPV_WITH_OPEN_VISIT_ERROR_MESSAGE =
  'Trying to create a new visit when there is an open already.';
